import { registrar_solicitacao_de_transferencia } from "./registrar-solicitacao-de-transferencia/registrar-solicitacao-de-transferencia";
import { confirmar_transferencia_escola_origem } from "./confirmar-transferencia-escola-origem/confirmar-transferencia-escola-origem";
import { guia_de_transferencias } from "./guia-de-transferencias/guia-de-transferencias";
import { manutencao_de_tipo_de_servico } from "./manutencao-de-tipo-de-servico/manutencao-de-tipo-de-servico";

const transferencia_do_aluno = [
  registrar_solicitacao_de_transferencia,
  confirmar_transferencia_escola_origem,
  guia_de_transferencias,
  manutencao_de_tipo_de_servico,
];

export { transferencia_do_aluno };
